import { jsx as _jsx } from "react/jsx-runtime";
import { useUITranslation } from "@vertesia/ui/i18n";
import { JSONCode } from './JSONCode.js';
import { JSONView } from './JSONView.js';
export function JSONDisplay({ value, viewCode = false }) {
    const { t } = useUITranslation();
    if (!value) {
        return (_jsx("pre", { className: "whitespace-pre-wrap", children: t('misc.noData') }));
    }
    return (_jsx("div", { className: 'relative w-full h-full flex flex-col', children: viewCode
            ? _jsx(JSONCode, { data: value })
            : _jsx("div", { className: "flex-1 min-h-0 overflow-auto", children: _jsx(JSONView, { value: value }) }) }));
}
//# sourceMappingURL=JSONDisplay.js.map